export default "__VITE_ASSET__XVC6ZPKt__"